export default __webpack_public_path__ + "static/media/part_4.1bc7fadf.png";